/**
 * WICHTIG: Hier dürfen keine .vue-Komponenten importiert werden, da
 * sonst zyklische Abhängigkeiten entstehen! Darum müssen Komponenten 
 * in einem separaten modul registriert werden...
 * 
 * WICHTIG: Bei Änderungen zyklsiche Abhängigkeiten beachten!
 *  
 * <layout-enty.js>  -> *-register.js -> *.-resolver.js
 * *-register.js -> *.vue
 * *.vue -> *.resolver.js
 */
import Vue from "vue";

import Logger from "../../../shared/logger";
const LOGGER = new Logger(__filename);

const uiTypeToComponentName = {};

/**
 * @param {*} component Die Vue-Komponente
 * @param {*} uiType Der verknüpfte UI-Type
 */
export const registerFragmentComponent = function (component, uiType) {
    let name = component.name;
    LOGGER.log(`register component name=${name} uiType=${uiType}`);
    Vue.component(name, component); // register global...
    uiTypeToComponentName[uiType] = name;
};

export const resolveFragmentComponentName = function (fragment) {
    const uiType = fragment.uiType;
    const name = uiTypeToComponentName[uiType] || null;
    if (name !== null) {
        return name;
    }
    LOGGER.error("no renderer found for uiType: " + uiType);
    return "fragment-not-found"; // see fragment-not-found.vue
};

export const showWarningsForUnsupportedUiTypes = function (uiTypesSupportedByBackend = []) {
    uiTypesSupportedByBackend.forEach(uiType => {
        if (!uiTypeToComponentName[uiType]) {
            LOGGER.warn(`the uiType '${uiType}' is not supported`);
        }
    });
};


